import React from 'react';
import { useIntl } from 'react-intl';
import { ObjectSchema } from 'yup';

import { AppointmentFormCustomerSection } from '../AppointmentFormCustomerSection';

import styles from './CustomerSearchSection.module.scss';

type InlineCustomerFormProps = {
  schema: ObjectSchema<any>;
  onBackToSearch: () => void;
};

function InlineCustomerFormComponent({ schema, onBackToSearch }: InlineCustomerFormProps) {
  const intl = useIntl();

  return (
    <div className={styles.inlineForm} data-testid="series-inline-customer-form">
      <div className={styles.inlineFormHeader}>
        <span className={styles.inlineFormTitle}>
          {intl.formatMessage({ id: 'seriesbooking.booking.createNewCustomer' })}
        </span>
        <button
          type="button"
          className={styles.inlineFormBackLink}
          data-testid="series-inline-customer-back"
          onClick={onBackToSearch}
        >
          {intl.formatMessage({ id: 'seriesbooking.booking.backToSearch' })}
        </button>
      </div>

      <AppointmentFormCustomerSection size="default" schema={schema} />
    </div>
  );
}

export const InlineCustomerForm = React.memo(InlineCustomerFormComponent);
